import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Sample_Report_Filter from "./sample_report_filter/Sample_Report_Filter";
import "./Sample_Report.css";
import Sample_Report_Table from "./sample_report_table/Sample_Report_Table";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";

const Sample_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Sample Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Sample_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Sample_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Sample Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Sample_Report;
